import React from 'react';
import Button from '../components/ui/Button';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';

const Contact = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message. We will contact you shortly.');
  };

  return (
    // Increased top padding from pt-24 to pt-36
    <div className="page-transition pt-36 pb-20">
      <div className="container mx-auto px-6">
        <h1 className="text-4xl md:text-5xl mb-12 text-center">Contact Us</h1>
        
        <div className="grid lg:grid-cols-2 gap-16">
          {/* Contact Info */}
          <div className="space-y-10">
            <div>
              <h2 className="text-2xl font-serif mb-6">Amani Palms <span className="text-base font-sans font-light block">by Manolo Beach Resort</span></h2>
              <div className="space-y-4 text-lg text-brand-700">
                <div className="flex items-start gap-4">
                  <FiMapPin className="mt-1 text-brand-500" />
                  <p>Dikoni Street<br/>Uroa, Tanzania</p>
                </div>
                <div className="flex items-center gap-4">
                  <FiPhone className="text-brand-500" />
                  <p>+255 677 522 140</p>
                </div>
                <div className="flex items-center gap-4">
                  <FiMail className="text-brand-500" />
                  <p>contact@manoloresort.com</p>
                </div>
              </div>
            </div>

            <div className="bg-brand-50 p-8 rounded-lg">
              <h3 className="text-xl font-serif mb-3">Airport Shuttle (paid)</h3>
              <p className="text-brand-600 mb-4">
                The nearest airport is Zanzibar Airport (34 km). We offer a paid airport shuttle. Please contact us to arrange your transfer.
              </p>
            </div>
          </div>

          {/* Form */}
          <div className="bg-white p-8 shadow-lg rounded-lg border border-brand-100">
            <h2 className="text-2xl mb-6">Send us a Message</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-brand-700 mb-1">Full Name</label>
                <input type="text" required className="w-full px-4 py-2 border border-brand-200 rounded-md focus:ring-brand-500 focus:border-brand-500 outline-none" placeholder="Your Name" />
              </div>
              <div>
                <label className="block text-sm font-medium text-brand-700 mb-1">Email</label>
                <input type="email" required className="w-full px-4 py-2 border border-brand-200 rounded-md focus:ring-brand-500 focus:border-brand-500 outline-none" placeholder="your@email.com" />
              </div>
              <div>
                <label className="block text-sm font-medium text-brand-700 mb-1">Phone (optional)</label>
                <input type="tel" className="w-full px-4 py-2 border border-brand-200 rounded-md focus:ring-brand-500 focus:border-brand-500 outline-none" placeholder="+123..." />
              </div>
              <div>
                <label className="block text-sm font-medium text-brand-700 mb-1">Message</label>
                <textarea required rows="4" className="w-full px-4 py-2 border border-brand-200 rounded-md focus:ring-brand-500 focus:border-brand-500 outline-none" placeholder="How can we help you?"></textarea>
              </div>
              <div className="flex items-start gap-2">
                <input type="checkbox" required id="consent" className="mt-1" />
                <label htmlFor="consent" className="text-sm text-brand-600">I agree that my data is processed to handle my request.</label>
              </div>
              <Button variant="primary" className="w-full">Send Message</Button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;